const actions = {
  LOAD_PLAYBACK: "LOAD_PLAYBACK",
  HANDLE_NEXT_TRACK: "HANDLE_NEXT_TRACK",
  LOAD_NEXT_TRACK: "LOAD_NEXT_TRACK",
  LOAD_EMPTY_PLAYBACK: "LOAD_EMPTY_PLAYBACK",

  STOP_PLAYBACK: "STOP_PLAYBACK",
  START_PLAYBACK: "START_PLAYBACK",
  PLAY_PLAYBACK: "PLAY_PLAYBACK",
  PAUSE_PLAYBACK: "PAUSE_PLAYBACK",
  SKIP_PLAYBACK: "SKIP_PLAYBACK",
  FAIL_COMMAND: "FAIL_COMMAND",

  START_INITIALIZE_PLAYBACK_REQUEST: "START_INITIALIZE_PLAYBACK_REQUEST",
  END_INITIALIZE_PLAYBACK_REQUEST: "END_INITIALIZE_PLAYBACK_REQUEST",
  SUCCESS_INITIALIZE_PLAYBACK: "SUCCESS_INITIALIZE_PLAYBACK",
};

export default actions;
